// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './components/Login';
import SignUp from './components/SignUp';
import LandingPage from './components/LandingPage';
import Gallery from './components/Gallery';
import Feedback from './components/Feedback';
import Appointment from './components/Appointment';
import Logout from './components/Logout';

// Admin Components
import AdminDashboard from './components/admin/AdminDashboard.js';
import ImageUpload from './components/admin/ImageUpload';
import ImageManager from './components/admin/ImageManager';
import AppointmentList from './components/admin/AppointmentList';
import FeedbackMessageList from './components/admin/FeedbackMessageList';
import DashboardContent from './components/admin/DashboardContent';
import AdminChangePassword from './components/admin/AdminChangePassword'; // NEW: Import AdminChangePassword

// User Components
import UserDashboard from './components/UserDashboard';

// AdminProtectedRoute: Ensures only authenticated *admin* users can access child routes
const AdminProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('token');
  const userRole = localStorage.getItem('userRole');
  const location = useLocation();

  console.log('AdminProtectedRoute: Checking access for path:', location.pathname);
  console.log('AdminProtectedRoute: isAuthenticated:', isAuthenticated ? 'true' : 'false', 'userRole:', userRole);

  if (!isAuthenticated || userRole !== 'admin') {
    console.warn('AdminProtectedRoute: Access denied. Not authenticated or not an admin. Redirecting to login.');
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  console.log('AdminProtectedRoute: Access granted.');
  return children;
};

// UserProtectedRoute: Ensures only authenticated *regular* users can access child routes
const UserProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('token');
  const userRole = localStorage.getItem('userRole');
  const location = useLocation();

  console.log('UserProtectedRoute: Checking access for path:', location.pathname);
  console.log('UserProtectedRoute: isAuthenticated:', isAuthenticated ? 'true' : 'false', 'userRole:', userRole);

  // If not authenticated OR if authenticated but an admin, redirect to login (admins use admin dashboard)
  if (!isAuthenticated || userRole === 'admin') {
    console.warn('UserProtectedRoute: Access denied. Not authenticated or is an admin. Redirecting to login.');
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  console.log('UserProtectedRoute: Access granted.');
  return children;
};


function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />

          {/* Forms that require authentication */}
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/appointment" element={<Appointment />} />

          {/* User Dashboard Route - Protected */}
          <Route
            path="/user-dashboard"
            element={
              <UserProtectedRoute>
                <UserDashboard />
              </UserProtectedRoute>
            }
          />

          {/* Admin Routes - Nested under AdminDashboard and Protected by AdminProtectedRoute */}
          <Route
            path="/admin"
            element={
              <AdminProtectedRoute>
                <AdminDashboard />
              </AdminProtectedRoute>
            }
          >
            <Route index element={<DashboardContent />} />
            <Route path="dashboard" element={<DashboardContent />} />
            <Route path="upload-image" element={<ImageUpload />} />
            <Route path="image-manager" element={<ImageManager />} />
            <Route path="appointments" element={<AppointmentList />} />
            <Route path="feedback" element={<FeedbackMessageList />} />
            <Route path="change-password" element={<AdminChangePassword />} /> {/* NEW: Route for password change */}
          </Route>

          {/* Fallback for any unmatched routes */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;